export interface InboxState {
    numberOfNewMessages: number;
    messages: InboxMessage[];
    messageResponseStatus: MessagesRequest;
}

export interface InboxMessage {
    id: number;
    opened: boolean;
    clicked: boolean;
    createdTime: number;
    expirationTime: number;
    message: MessageBody;
}

export interface MessageBody {
    cid: string;
    title: string;
    alert: string;
    icon: string;
    id: number;
    style: MessageStyle;
    payloadMap?: PayloadMap;
    url?: string;
    shouldOpenUrlInBlank?: boolean;
    urlMode?: string;
    deepLink?: string;
}

export interface PayloadMap {
    buttonText?: string;
    terms?: string;
    webDeeplink?: string;
}

export interface MessageStyle {
    background: string;
    titleBackground: string;
    type: string;
}

export type MessageRequestStatus =
    | MessageRequestPending
    | MessageRequestSuccess
    | MessageRequestError;

export const MessagesRequest = {
    Pending: 'Pending',
    Success: 'Success',
    Error: 'Error',
    LoadFail: 'LoadFail',
};
export type MessagesRequest = typeof MessagesRequest[keyof typeof MessagesRequest];

type MessageRequestPending = {
    state: typeof MessagesRequest.Pending;
};

export type MessageRequestSuccess = {
    state: typeof MessagesRequest.Success;
    response: InboxMessage[];
};

type MessageRequestError = {
    state: typeof MessagesRequest.Error | typeof MessagesRequest.LoadFail;
};
